<template>
    <div class="ourTeam">
        <v-app>
            <div id="grad">
                     <v-container class="my-5">
                    <v-row justify="center" class="my-2 white--text">
                        <h3>OUR TEAM</h3>
                    </v-row>
                    <v-row justify="center" class="my-2 white--text">
                        <h5>Team Leader & Flutter/Web Developer</h5>
                   
                    </v-row>
                    <v-layout row wrap justify-center="true">
                        <v-flex xs4 md3 v-for="person in teamLeader" :key="person.name">
                            <v-card class="text-center ma-md-5 ma-3">
                                <v-responsive class="pt-4">
                                    <v-avatar size="80">
                                        <img :src="person.avatar"/>
                                    </v-avatar>
                                </v-responsive>
                                <v-card-text>
                                    <div class="text-sm-button text-body2" style="color: black;">{{ person.name }}</div>
                                    <!-- <div class="grey--text text-caption">{{ person.role }}</div> -->
                                </v-card-text>
                                <v-card-actions class="center">
                                   
                                    <v-btn class="mx-2" fab dark small @click="onClick(person.link)" color="primary" absolute>
                                        <v-icon dark>mdi-linkedin</v-icon>
                                    </v-btn>
                                    
                                </v-card-actions>
                            </v-card>
                        </v-flex>
                    </v-layout>
                    <v-row justify="center" class="my-2 white--text">
                        <h5>Web Developers</h5>
                    </v-row>
                     <v-layout row wrap justify-center="true">
                        <v-flex xs4 md3 v-for="person in WebDevelopers" :key="person.name">
                            <v-card class="text-center ma-md-5 ma-3">
                                <v-responsive class="pt-4">
                                  <v-avatar size="80">
                                        <img :src="person.avatar"/>
                                    </v-avatar>
                                </v-responsive>
                                <v-card-text>
                                    <div class="text-sm-button text-body2" style="color: black;">{{ person.name }}</div>
                              
                                </v-card-text>
                                <v-card-actions class="center">
                                    <v-btn class="mx-2" fab dark small @click="onClick(person.link)" color="primary" absolute>
                                        <v-icon dark>mdi-linkedin</v-icon>
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-flex>
                    </v-layout>
                             <v-row justify="center" class="my-2 white--text">
                        <h5>Web Designer</h5>
                    </v-row>
                     <v-layout row wrap justify-center="true">
                        <v-flex xs4 md3 v-for="person in WebDesigner" :key="person.name">
                            <v-card class="text-center ma-md-5 ma-3">
                                <v-responsive class="pt-4">
                                  <v-avatar size="80">
                                        <img :src="person.avatar"/>
                                    </v-avatar>
                                </v-responsive>
                                <v-card-text>
                                    <div class="text-sm-button text-body2" style="color: black;">{{ person.name }}</div>
                              
                                </v-card-text>
                                <v-card-actions class="center">
                                    <v-btn class="mx-2" fab dark small @click="onClick(person.link)" color="primary" absolute>
                                        <v-icon dark>mdi-linkedin</v-icon>
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-flex>
                    </v-layout>

                    <v-row justify="center" class="my-2 white--text">
                        <h5>Flutter Developers</h5>
                    </v-row>
                     <v-layout row wrap justify-center="true">
                        <v-flex xs4 md3 v-for="person in FlutterDevelopers" :key="person.name">
                            <v-card class="text-center ma-md-5 ma-3">
                                <v-responsive class="pt-4">
                                    <v-avatar size="80">
                                        <img :src="person.avatar"/>
                                    </v-avatar>
                                </v-responsive>
                                <v-card-text>
                                    <div class="text-sm-button text-body2" style="color: black;">{{ person.name }}</div>
                                   
                                </v-card-text>
                                <v-card-actions class="center">
                                    <v-btn class="mx-2" fab dark small @click="onClick(person.link)" color="primary" absolute>
                                        <v-icon dark>mdi-linkedin</v-icon>
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-flex>
                    </v-layout>

                    <v-row justify="center" class="my-2 white--text">
                        <h5>Research , Data Analysis & Marketing</h5>
                    </v-row>
                     <v-layout row wrap justify-center="true">
                        <v-flex xs4 md3 v-for="person in Marketing" :key="person.name">
                            <v-card class="text-center ma-md-5 ma-3">
                                <v-responsive class="pt-4">
                                     <v-avatar size="80">
                                        <img :src="person.avatar"/>
                                    </v-avatar>
                                </v-responsive>
                                <v-card-text>
                                    <div class="text-sm-button text-body2" style="color: black;">{{ person.name }}</div>
                                   
                                </v-card-text>
                                <v-card-actions class="center">
                                    <v-btn class="primary mx-2 my-2" fab dark small @click="onClick(person.link)" color="primary" absolute>
                                        <v-icon dark>mdi-linkedin</v-icon>
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-container>
            </div>
        </v-app>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                teamLeader: [
                    { name: 'Hardik Vij',  avatar: '/hardik2.jpg' , link: 'https://www.linkedin.com/in/hardik-vij/' },                
                ],
                WebDevelopers: [
                    { name: 'Mehak Bhatia', avatar: '/mehak.jpeg' , link:'https://www.linkedin.com/in/mehakb-' },
                    { name: 'Sidharth Bhasin',  avatar: '/sid.jpeg' , link:'http://linkedin.com/in/sidharthbhasin3'},
                    { name: 'Sagar Kumar', avatar: '/sagar.jpeg' , link:'https://www.linkedin.com/mwlite/in/sagar-kumar-6aa0a4188'},
                    { name: 'Aditi Chandra', avatar: '/aditi.jpeg' , link:'https://www.linkedin.com/in/aditi-chandra-70396816b'},
                    { name: 'Sparsh Jaiswal', avatar: '/sparsh.jpg' , link:'https://www.linkedin.com/in/sparsh-jaiswal-240486154'},
                    { name: 'Simra Husain', avatar: '/simra.jpeg' , link:'https://www.linkedin.com/in/simra-husain-63668815a'},
                ],
                WebDesigner: [
                    { name: 'Shivansh Prasad', avatar: '/shivansh.jpeg' , link:'https://www.linkedin.com/in/shivansh-prasad-15689a159'},
                ],
                FlutterDevelopers: [
                    { name: 'Shivendra Pratap Singh', avatar: '/shivam.jpeg' , link:'https://www.linkedin.com/in/shivendra-pratap-singh-839714185'},
                    { name: 'Manish Verma',  avatar: '/manish.jpg' , link:'https://www.linkedin.com/in/manish-verma-ab2722175'},
                    { name: 'Neeraj Narang',  avatar: '/neeraj.jpeg' , link:'http://linkedin.com/in/neeraj-narang-548007185'},
                    { name: 'Adarsh Pal', avatar: '/adarsh.jpg' , link:'https://www.linkedin.com/in/adarsh-pal-99927a194/'},
                ],
                Marketing: [
                    
                    { name: 'Gauri Shivhare', avatar: '/gauri.jpeg' , link:'https://www.linkedin.com/in/gauri-shivhare-97756a1a1'},
                    { name: 'Ashish Pandey',  avatar: '/ashish.jpg' , link:'https://www.linkedin.com/in/ashish-pandey-3b64631b4/'},
                    { name: 'Mayur Negi',  avatar: '/mayur.jpeg' , link:'https://www.linkedin.com/in/mayur-negi-49036818a'},   
                    { name: 'Arpit Kumar',  avatar: '/arpit.jpeg' , link:'https://www.linkedin.com/in/arpit-kumar-7369811b1'},
                    { name: 'Sanskriti Pandey',  avatar: '/sanskriti.jpg' , link:'https://www.linkedin.com/in/sanskriti-pandey-b99639157'},
                    { name: 'Punya Bansal',  avatar: '/punya.jpg' , link:'https://www.linkedin.com/in/punya-bansal-4489901b0/'},
                ]
            }
        },
        methods:{

            onClick(link){
                window.open( link, "_blank");
                console.log('Open Link -- ' + link)
            }



        }
    }
</script>

<style lang="scss" scoped>

@import url('https://fonts.googleapis.com/css2?family=Modak&display=swap');

#grad { 
     background-image: linear-gradient( #3594DD ,  #4563DB,
                  #5036D5,
                  #5B16D0);
   height: 100%;
}

button:focus {
   outline:none;
}

</style>